export const environment = {
  production: true,
    "ApiHost":"https://bocw.punjab.gov.in/bocwapi",
   //"ApiHost":"http://20.244.5.14/bocwapi",  //staging

    "APIHOSTCESS":"http://pblabour.gov.in/bocwnode",
    "Assetbase":"/bocwapp/",
   // "Assetbase":"/bocwapp/",
    "cscCallback":"https://bocw.punjab.gov.in/bocwapi",
	  "testcscCallback":"http://bocw.punjab.gov.in",
	  "cscClientId":"f0b4faa0-c880-407c-d5bb-dc9530218996",
	  "BACK_TO_ELAB_PATH":"https://pblabour.gov.in/eLabour/Account/LoginFromPWBS",
    "BACK_TO_ELAB_PATH_stg":"https://pblabour.gov.in/eLabour/Account/LoginFromPWBS",
    "logoutLink":"https://pblabour.gov.in/",
    "NODE_TLS_REJECT_UNAUTHORIZED":1,
    "rptUrl": "https://bocw.punjab.gov.in/brpt/LGReports.aspx?enc=",
    "aesKey": "8097276631449410",
    "aesIV": "7996209429192123",
};